import React, { useEffect, useState } from "react";
import Header from "../../components/common/header";
import imagePaths from "../../assets/imagePaths";
import { GoStack } from "react-icons/go";
import api from "../../api/api.js";
import { ApiResponse } from "../../models/ApiResponseModel";
import { logMessage } from "../../utils/helpers.js";
import { useNavigate } from "react-router-dom";
import paths from "../../utils/constants.js";
import { LeaderboardOuter } from "../../models/leaderboardModel.js";

const LeaderBoard = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("current");
  const [activeTier, setActiveTier] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [leaderboardData, setLeaderboardData] = useState(
    new LeaderboardOuter({})
  );
  const [showPopup, setShowPopup] = useState(false);

  const fetchProjects = async () => {
    try {
      startLoading();
      const data = {
        type: activeTab,
        page: currentPage,
        updatePagination: "yes",
      };
      if (activeTier) {
        data.tier = activeTier;
      }
      const response = await api.getLeaderboard(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        setLeaderboardData(response.data);
        if (!activeTier && response.data.activeTier) {
          setActiveTier(response.data.activeTier);
        }
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      stopLoading();
    }
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleTierChange = (tierKey) => {
    setActiveTier(tierKey);
    setCurrentPage(1);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || token.length <= 0) {
      navigate(paths.AUTH_SCREEN);
    } else {
      if (activeTab !== "") {
        fetchProjects();
      }
    }
  }, [activeTab, currentPage, activeTier]);

  const tiers = leaderboardData.tiers || [];

  return (
    <div className="full_page_inner">
      <Header />
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup onlyInfoPopUp">
            <p style={{ fontWeight: 700 }}>Leaderboard Information</p>
            <p style={{ fontWeight: 400, fontSize: "14px" }}>
              <span style={{ fontWeight: 600, color: "#323232" }}>
                The Current Leaderboard
              </span>{" "}
              resets every two months, and prizes are awarded accordingly. Time
              is calculated based on the start and end dates of your projects.
            </p>
            <p style={{ fontWeight: 400, fontSize: "14px" }}>
              <span style={{ fontWeight: 600, color: "#323232" }}>
                The All-Time Leaderboard
              </span>{" "}
              is an accumulation of all approved projects with no specific
              timeframes.
            </p>
            <p style={{ fontWeight: 400, fontSize: "14px" }}>
              <span style={{ fontWeight: 600, color: "#323232" }}>
                Points Calculation:
              </span>{" "}
              Points are based on the number of projects completed multiplied by
              the size of the canvas. Proof is required through start and end
              date photos, which we manually verify.
            </p>
            <p style={{ fontWeight: 700 }}>Example</p>
            <p style={{ fontWeight: 400, fontSize: "14px" }}>
              • 1 project (80cm x 60cm) = 4,800 points
            </p>
            <p style={{ fontWeight: 400, fontSize: "14px" }}>
              • 1 project (40cm x 50cm) = 2,000 points
            </p>
            <p style={{ fontWeight: 400, fontSize: "14px" }}>
              <span style={{ fontWeight: 600, color: "#323232" }}>
                Total Score:{" "}
              </span>{" "}
              4,800 + 2,000 = 6,800 points
            </p>
            <button
              className="delete-button doneInfoButton"
              onClick={togglePopup}
            >
              Done
            </button>
          </div>
        </div>
      )}

      <div
        className="dashboard_container leaderboard_outer_container"
        style={{ backgroundImage: `url(${imagePaths.leaderboard})` }}
      >
        <div className="leaderboard_container">
          <div className="topButtonConatiner">
            <div className="leftTop">
              <button
                className={`current ${activeTab === "current" ? "active" : ""}`}
                onClick={() => handleTabChange("current")}
              >
                Current
              </button>
              <button
                className={`all_time ${
                  activeTab === "all_time" ? "active" : ""
                }`}
                onClick={() => handleTabChange("all_time")}
              >
                All-Time
              </button>
            </div>
          </div>
          <p onClick={togglePopup} className="howInfo">
            How The Leaderboard Works?{" "}
            <img
              onClick={togglePopup}
              style={{ cursor: "pointer", width: "18px", marginLeft: "8px" }}
              src={imagePaths.info}
              alt="info"
            />{" "}
          </p>
          <p className="leaderboardDescription">
            {leaderboardData.description}
          </p>

          {/* Tier Filter Tabs */}
          {tiers.length > 0 && (
            <div className="tierFilterContainer">
              {tiers.map((t) => (
                <button
                  key={t.key}
                  className={`tierFilterBtn ${activeTier === t.key ? "tierFilterBtnActive" : ""}`}
                  style={
                    activeTier === t.key
                      ? { backgroundColor: "#4a2e8c", color: "#fff", borderColor: "#4a2e8c" }
                      : {}
                  }
                  onClick={() => handleTierChange(t.key)}
                >
                  {t.name.replace(" Tier", "")}
                </button>
              ))}
            </div>
          )}

          {leaderboardData.first || leaderboardData.second || leaderboardData.third ||
          leaderboardData.participants.length > 0 ? (
            <div className="innerWinnerContainer" style={{ display: "block" }}>
              <div className="topWinnerContainer">
                <div className="secondWinnerCard commonWinnerCard">
                  <div className="imageSections">
                    <img
                      className="profileImage"
                      src={
                        leaderboardData.second?.profile_picture
                          ? leaderboardData.second?.profile_picture
                          : imagePaths.demo_profile
                      }
                      alt="Profile"
                    />
                    <div className="badgeWrapper">
                      <img
                        className="badge"
                        src={imagePaths.silver}
                        alt="Badge"
                      />
                      <span className="badgeText">
                        {leaderboardData.second?.rank}
                      </span>
                    </div>
                  </div>
                  <p className="leaderboardName">
                    {leaderboardData.second?.name || "Guest"}
                  </p>
                  <div className="middleSection">
                    <img src={imagePaths.reward} alt="Reward" />
                    <p>
                      <span className="numberPts">
                        {leaderboardData.second?.total_points || 0}
                      </span>{" "}
                      pts
                    </p>
                  </div>
                  <div className="bottomSection">
                    <GoStack />
                    <p>{leaderboardData.second?.user_level || leaderboardData.second?.numberOfProjects || 0}</p>
                  </div>
                </div>
                <div
                  className="firstWinnerCard"
                  style={{ backgroundImage: `url(${imagePaths.firstwinner})` }}
                >
                  <div className="imageSections">
                    <img
                      className="profileImage"
                      src={
                        leaderboardData.first?.profile_picture
                          ? leaderboardData.first?.profile_picture
                          : imagePaths.demo_profile
                      }
                      alt="Profile"
                    />
                    <div className="badgeWrapper">
                      <img
                        className="badge"
                        src={imagePaths.gold}
                        alt="Badge"
                      />
                      <span className="badgeText">
                        {leaderboardData.first?.rank}
                      </span>
                    </div>
                  </div>
                  <p className="leaderboardName">
                    {leaderboardData.first?.name}
                  </p>
                  <div className="middleSection">
                    <img src={imagePaths.reward} alt="Reward" />
                    <p>
                      <span className="numberPts">
                        {leaderboardData.first?.total_points}
                      </span>{" "}
                      pts
                    </p>
                  </div>
                  <div className="bottomSection">
                    <GoStack />
                    <p>{leaderboardData.first?.user_level || leaderboardData.first?.numberOfProjects}</p>
                  </div>
                </div>

                <div className="thirdWinnerCard commonWinnerCard">
                  <div className="imageSections">
                    <img
                      className="profileImage"
                      src={
                        leaderboardData.third?.profile_picture
                          ? leaderboardData.third?.profile_picture
                          : imagePaths.demo_profile
                      }
                      alt="Profile"
                    />
                    <div className="badgeWrapper">
                      <img
                        className="badge"
                        src={imagePaths.bronze}
                        alt="Badge"
                      />
                      <span className="badgeText thirdBadgeText">
                        {leaderboardData.third?.rank}
                      </span>
                    </div>
                  </div>
                  <p className="leaderboardName">
                    {leaderboardData.third?.name || "Guest"}
                  </p>
                  <div className="middleSection">
                    <img src={imagePaths.reward} alt="Reward" />
                    <p>
                      <span className="numberPts">
                        {leaderboardData.third?.total_points || "0"}
                      </span>{" "}
                      pts
                    </p>
                  </div>
                  <div className="bottomSection">
                    <GoStack />
                    <p>{leaderboardData.third?.user_level || leaderboardData.third?.numberOfProjects || "0"}</p>
                  </div>
                </div>
              </div>
              {leaderboardData.participants.length > 0 && (
                <div className="bottomWinnerContainer">
                  {leaderboardData.participants
                    .slice(0)
                    .map((participant, index) => (
                      <div className="tilesContainer" key={index}>
                        <div className="leftTileSide">
                          <span
                            className="rankBadge"
                            style={{
                              backgroundImage: `url(${imagePaths.tilesreward})`,
                            }}
                          >
                            {participant.rank}
                          </span>
                          <img
                            className="profileImage"
                            src={
                              participant.profile_picture
                                ? participant.profile_picture
                                : imagePaths.demo_profile
                            }
                            alt="Profile"
                          />
                          <span className="userName">
                            {participant.name || "Unknown User"}
                          </span>
                        </div>
                        <div className="middleTileSide">
                          <div className="score">
                            <GoStack />
                            <span className="stackValue">
                              {participant.user_level || participant.numberOfProjects || "0"}
                            </span>
                          </div>
                        </div>
                        <div className="rightTileSide">
                          <div className="points">
                            <img
                              className="icon"
                              src={imagePaths.reward}
                              alt="Points Icon"
                            />
                            <span className="pointsValue">
                              {participant.total_points || "0"} pts
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )}
              <div className="leaderboard-pagination-container">
                <button
                  className="pagination-button previous"
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="currentPageLeaderboard">{currentPage}</span>
                <button
                  className="pagination-button next"
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={!leaderboardData.hasNextPage}
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            <p className="noUsersText">Currently no data available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderBoard;
